import type { BluffGamePhase } from "./answerBluffGamePayload";

/** Prompt and answer field share one timed window (combined QA). */
export function bluffQaCombinedPhase(phase: BluffGamePhase): boolean {
  return phase === "question" || phase === "answer";
}
